/* eslint-disable spire/export-styles */
import { rem } from "@affinity/constants/StyleHelpers";
import Button from "@affinity/MobiusOverrides/Button/Button";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import * as React from "react";
import styled from "styled-components";

const enum fields {
    variant = "variant",
    label = "label",
    link = "link",
    alignment = "alignment",
    iconVariant = "iconVariant",
    iconLocation = "iconLocation",
    variantSize = "variantSize",
}

interface OwnProps extends WidgetProps {
    fields: {
        [fields.label]: string;
        [fields.link]: string;
    };
}

export const TelephoneLinkButton: React.FC<OwnProps> = ({ fields }) => {
    return (
        <ContentWrapper>
            <Button
                variant="tertiary"
                sizeVariant="large"
                href={`tel:${fields.link}`}
                icon={{
                    src: "Phone",
                    position: "left",
                }}
            >
                {fields.label}
            </Button>
        </ContentWrapper>
    );
};

export const ContentWrapper = styled.div`
    display: flex;
    width: 100%;
    justify-content: flex-start;
    padding: ${rem(10)} 0;
`;

const widgetModule: WidgetModule = {
    component: TelephoneLinkButton,
    definition: {
        group: "Basic",
        icon: "rectangle-wide",
        fieldDefinitions: [
            {
                name: fields.label,
                displayName: "Button Label",
                editorTemplate: "TextField",
                defaultValue: "",
                fieldType: "Translatable",
            },
            {
                name: fields.link,
                displayName: "Button Link",
                editorTemplate: "TextField",
                defaultValue: "",
                fieldType: "General",
            },
        ],
    },
};

export default widgetModule;
